import { Stack } from '@mui/material'
import { useAtomValue } from 'jotai'
import { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useIsErrorChain } from 'store/app/hooks'
import { FaucetLayer1 } from './FaucetLayer1'
import { FaucetLayer2 } from './FaucetLayer2'
import { FaucetTabs } from './FaucetTabs'
import { FaucetNetworkSelection } from './NetworkSelection'
import { FaucetType, faucetTypeAtom } from './atoms'
import { updateModal } from '../../store/app/actions/modalActions'

export const FaucetMain = memo(() => {
  const dispatch = useDispatch()
  const isErrorChain = useIsErrorChain()
  const faucetType = useAtomValue(faucetTypeAtom)

  useEffect(() => {
    dispatch(
      updateModal({
        modal: 'faucet',
        open: false,
      })
    )
  }, [])

  return (
    <Stack
      sx={{ pb: 2 }}
      spacing={2}
      onClick={(e) => {
        e.stopPropagation()
      }}>
      <FaucetTabs />

      {isErrorChain ? (
        <FaucetNetworkSelection />
      ) : faucetType === FaucetType.Layer2 ? (
        <FaucetLayer2 />
      ) : faucetType === FaucetType.Layer1 ? (
        <FaucetLayer1 />
      ) : null}
    </Stack>
  )
})
